import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, getMyUtenti } from 'src/app/store/app.state';
import { UtilityService } from '../services/utility.service';
import { Resource } from '../models/resource.model';
import { take } from 'rxjs/operators';

/**Pure pipe che recupera i titoli dei trattati cui si riferiscono delle sottorisorse */
@Pipe({
  name: 'getTractateTitle'
})
export class GetTractateTitlePipe implements PipeTransform {

  /**
   * 
   * @param store {Store<AppState>} stato a livello dell'applicazione
   * @param utility {UtilityService} classe che raccoglie una serie di servizi di utilità
   */
  constructor(
    private store: Store<AppState>,
    private utility: UtilityService
  ) {}

  /**
   * Metodo dell'interfaccia PipeTransform
   * @param risorsa {Resource} risorsa della quale recuperare il nome del trattato di riferimento
   * @returns {string}
   */
  transform(risorsa: any, ...args: any[]): any {
    let tractatesList: Resource[];
    this.store.select(getMyUtenti).pipe(take(1)).subscribe(data => {
      tractatesList = data.elencoTrattati.slice();
    })
    return this.utility.getTractateTitle(risorsa, tractatesList);
  }

}
